import React, { useContext } from 'react'
import { PluginContext } from '@flamingo_tech/funkgo'
import styles from './CollectionTags.module.css'
import cx from '../../../utils/className'

import Image from '../../common/Image/Image'
import Pressable from '../../common/Pressable/Pressable'
import withSliderTouch from '../../../hooks/withSliderTouch'
import CollectionPCTags from './CollectionPCTags'

const CollectionImageTags = ({ isDesktop, list, disableClick, onItemClick, tiny, $i18n }) => {
  const renderImageList = () => {
    return list.map((item, index) => (
      <Pressable
        key={index}
        className={cx(styles.tagsImageItem, isDesktop && styles.isDesktop)}
        onClick={() => onItemClick(item, index)}
        disabled={disableClick}
        ariaLabel={item.name || $i18n.transl('shell.footer.category')}
      >
          <div className={styles.tagsImageBox}><Image tiny className={styles.image} src={item.img_url} lazy title={item.name || $i18n.transl('shell.footer.category')} /></div>
          <div className={styles.tagsName}>{item.name}</div>
      </Pressable>
    ))
  }

  if (isDesktop) {
    return <CollectionPCTags list={list} onItemClick={onItemClick} $i18n={$i18n} />
  }

  return (
    <div className={styles.CollectionImageTags}>
      <div className={tiny ? styles.tiny : styles.normal}>
        {renderImageList()}
      </div>
    </div>
  )
}

const CollectionTags = ({ list, disableClick, tiny }) => {
  const plugin = useContext(PluginContext)
  const isDesktop = plugin.$detector.isDesktop()

  if (!list || list.length === 0) {
    return null
  }

  const handleClick = (item, index) => {
    plugin.$track.clickMainResourceLocator(`Collection:Tag_${item.name}`, {
      url: item.link,
      index,
    })
    plugin.$router.navigate(item.link)
  }

  if (list && list[0].img_url) {
    return <CollectionImageTags tiny={tiny} isDesktop={isDesktop} onItemClick={handleClick} list={list} disableClick={disableClick} $i18n={plugin.$i18n} />
  }

  return (
    <div className={cx(styles.CollectionTags, isDesktop && styles.isDesktop)}>
      {
        list.map((item, index) => {
          return (
            <Pressable key={index} className={styles.tabItem} onClick={() => handleClick(item, index)} ariaLabel={item.name || plugin.$i18n.transl('shell.footer.category')}><span aria-hidden="true">{item.name}</span></Pressable>
          )
        })
      }
    </div>
  )
}

export default withSliderTouch(CollectionTags)